import { VStack } from 'native-base';
import { H3 } from '~/shared/Typography';
import React from 'react';
import { Button } from '../Theme';
import { useTheme } from '@springbig/shared';

type PopUpProps = {
    title: string;
    button: string;
    onProceed: () => void;
};

const PopUp = ({
    title,
    button,
    onProceed,
}: PopUpProps) => {

    const {
        card,
        button_primary
    } = useTheme();

    return (
        <VStack
            bg={card}
            p={4}
            space={1}
            alignItems={'center'}
            textAlign={'center'}
            w={'100%'}
            position={'relative'}
        >
            <H3 color={button_primary}>{ title }</H3>
            <Button
                onPress={onProceed}
                text={ button }
            />
        </VStack>
    );
};

export default PopUp;
